import {Grid, Box} from "@mui/material";
import {Routes, Route, Navigate, useLocation} from "react-router-dom";
import React, {useEffect} from "react";
import Barra from "./Barra/Barra";
import Footer from "./Footer";

// Secciones públicas
import Seccion_Comidas from "./Secciones/Seccion_Comidas";
import Seccion_Helados from "./Secciones/Seccion_Helados";
import Seccion_Bebidas from "./Secciones/Seccion_Bebidas";
import Seccion_Opinion from "./Secciones/Seccion_Opinion";
import Seccion_Pagina_Misteriosa from "./Secciones/Seccion_Pagina_Misteriosa";
import Seccion_Cono_Gratis from "./Secciones/Seccion_Cono_Gratis";

// Dashboard
import LayoutDashboard from "./Secciones/Componentes/LayoutDashboards";
import Seccion_Items from "../Pagina/Secciones/Seccion_Items";
import Crear_Misterio from "./Secciones/Componentes/Crear_Misterio";
import Crear_Misterio_Dashboard from "./Secciones/Componentes/Crear_Misterio_Dashboard";
import Editar_Misterio_Dashboard from "./Secciones/Componentes/Editar_Misterio_Dashboard";
import Opiniones from "./Secciones/Componentes/Opiniones";
import Crear_Clientes from "./Secciones/Componentes/Crear_Clientes";
import {PrivateRoute} from "../firebase/PrivateRoute";
import Seccion_Login from "./Secciones/Seccion_Login";
import TerminosCondiciones from "./Secciones/TerminosCondiciones";
import PoliticaPrivacidad from "./Secciones/PoliticaPrivacidad";
import PoliticaCookies from "./Secciones/PoliticaCookies";
import BotonWhatsApp from "./Secciones/Componentes/BotonWhatsApp";
import Seccion_ConoGratis_Dashboard from "./Secciones/Componentes/Seccion_ConoGratis_Dashboard";
import Seccion_Textos_Dashboard from "./Secciones/Componentes/Seccion_Textos_Dashboard";



const Pagina = () => {
    const location = useLocation();

    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
        return null;
    };

    return (
        <Grid container direction="column" minHeight="100vh">
            <ScrollToTop/>
            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{zIndex: 2}}>
                <Barra/>
            </Grid>
            <Box sx={{ width: "100%", overflow: "hidden" }}>
                <Routes>
                    <Route path="/" element={<Seccion_Comidas/>}/>
                    <Route path="*" element={<Seccion_Comidas/>}/>
                    <Route path="/comidas" element={<Seccion_Comidas/>}/>
                    <Route path="/helados" element={<Seccion_Helados/>}/>
                    <Route path="/bebidas" element={<Seccion_Bebidas/>}/>
                    <Route path="/danos-tu-opinion" element={<Seccion_Opinion/>}/>
                    <Route path="/pagina-misteriosa" element={<Seccion_Pagina_Misteriosa/>}/>
                    <Route path="/cono-gratis" element={<Seccion_Cono_Gratis/>}/>
                    <Route path="/login" element={<Seccion_Login/>}/>
                    <Route path="/terminos-y-condiciones" element={<TerminosCondiciones/>}/>
                    <Route path="/politica-de-privacidad" element={<PoliticaPrivacidad/>}/>
                    <Route path="/politica-de-cookies" element={<PoliticaCookies/>}/>

                    <Route path="/dashboard" element={
                        <PrivateRoute allowedRoles={["admin"]}>
                            <LayoutDashboard/>
                        </PrivateRoute>
                    }>
                        <Route index element={<Navigate to="comidas" replace/>}/>
                        <Route path="comidas" element={<Seccion_Items coleccion="comidas" titulo="Nueva Comida" coleccionDestacados="comidas-destacados" tituloDestacados="Nuevo Destacado Comida" coleccionTituloDestacados="comidas-titulo-destacados" mostrarPestanas={true} />}/>
                        <Route path="helados" element={<Seccion_Items coleccion="helados" titulo="Nuevo Helado" coleccionDestacados="helados-destacados" tituloDestacados="Nuevo Destacado Helado" coleccionTituloDestacados="helados-titulo-destacados" mostrarPestanas={true}/>}/>
                        <Route path="bebidas" element={<Seccion_Items coleccion="bebidas" titulo="Nueva Bebida"  coleccionDestacados="bebidas-destacados" tituloDestacados="Nuevo Destacado Bebida" coleccionTituloDestacados="bebidas-titulo-destacados" mostrarPestanas={true}/>}/>
                        <Route path="cono-gratis" element={<Seccion_ConoGratis_Dashboard />} />
                        <Route path="misterio" element={<Crear_Misterio/>}/>
                        <Route path="misterio/crear" element={<Crear_Misterio_Dashboard/>}/>
                        <Route path="misterio/:id" element={<Editar_Misterio_Dashboard/>}/>
                        <Route path="/dashboard/textos" element={<Seccion_Textos_Dashboard />} />
                        <Route path="clientes" element={<Crear_Clientes/>}/>
                    </Route>
                </Routes>
            </Box>

            {!(
                ["/cono-gratis"].includes(location.pathname) ||
                location.pathname.startsWith("/dashboard")
            ) && (
                <Grid item>
                    <Opiniones/>
                </Grid>
            )}
            {!(
                ["/pagina-misteriosa","/login"].includes(location.pathname) ||
                location.pathname.startsWith("/dashboard")
            ) && (
                <Grid item>
                    <BotonWhatsApp />
                </Grid>
            )}

            <Grid item>
                <Footer/>
            </Grid>
        </Grid>
    );
};

export default Pagina;
